import React, { useState } from 'react'
import { Box, Columns, Column, Icon, Button } from 'Components/common/bulma'
import { Table } from 'Components/common'
import { usersColumn } from './userDefinitions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'
import { Trans } from '@lingui/macro'
import { Link } from 'react-router-dom'
import { getUsersAction, deleteUserAction } from 'Modules/users'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActionMenu, ModalRemove } from 'Components/common'
import Loader from 'Components/common/page/loaderFloat';
import { push as pushAction } from 'connected-react-router';
import Show from 'Components/common/Show';
import { addNotification as addNotificationAction } from 'Modules/principal'


function Index({
  getUsers,
  users,
  push,
  deleteUser,
  addNotification,
}) {
  const [showModal, setShowModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [userWillRemove, setUserWillRemove] = useState(undefined)

  const onEdit = ({ id }) => {
    push(`/usuarios/${id}`)
  }

  const onRemove = ({ id }) => {
    setShowModal(true)
    setUserWillRemove(id)
  }

  const handleOnDelete = () => {
    setIsLoading(true)
    deleteUser(userWillRemove)
      .then(() => {
        setUserWillRemove(undefined)
        addNotification({
          type: 'success',
          message: 'El usuario se eliminó correctamente'
        })
        getUsers()
          .then(() => {
            setIsLoading(false)
          })
      }).catch(() => addNotification({
        type: 'danger',
        message: 'Ocurrió un error al eliminar el usuario'
      }))
    setShowModal(false)
  }
  const customColActions = (row, id, fetchData) => (<div style={{ width: '78px' }}>
    <ActionMenu>
      <Button small primary outlined onClick={() => onEdit(row)}>
        <Icon>
          <FontAwesomeIcon icon={faEdit} />
        </Icon>
      </Button>
      <Button small className="margin-left-xs" danger outlined onClick={() => onRemove(row, fetchData)}>
        <Icon>
          <FontAwesomeIcon icon={faTrash} />
        </Icon>
      </Button>
    </ActionMenu>
  </div>)

  return (
    <Box style={{ position: 'relative' }}>
      <Show canShow={isLoading}>
        <Loader />
      </Show>
      <ModalRemove
        isDeleting={showModal}
        title="Eliminar usuario"
        toggleModal={() => setShowModal(false)}
        confirmText="¿Desea eliminar al Usuario y revocar su tarjeta de acceso seguro?"
        resource=""
        deleteResource={handleOnDelete}
      />
      <Columns>
        <Column>
          <Link className="button is-success is-outlined is-pulled-right" to="/usuarios/nuevo">
            <Icon>
              <FontAwesomeIcon icon={faPlus} />
            </Icon>
            <Trans render="span">Agregar usuario</Trans>
          </Link>
        </Column>
      </Columns>
      <Table
        colsetup={usersColumn}
        coldata={users}
        tableClassName='table is-striped is-hoverable is-fullwidth'
        emptyTableMarkUp={<span>No hay registros</span>}
        customCol={{
          customColName: 'actions',
          renderFunc: customColActions
        }}
        initialFetch
        refresh={getUsers}
      />
    </Box>
  )
}

const mapStateToProps = ({ users }) => ({
  users: users.users,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getUsers: getUsersAction,
  push: pushAction,
  deleteUser: deleteUserAction,
  addNotification: addNotificationAction,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Index)


export { default as UserForm } from './userForm'